// extracted by mini-css-extract-plugin
export var drawerPaper = "_3c-0";
export var itemImage = "_3c-1";